export default {
  getPermissions: {
    method: 'get',
    url: 'manager/account/permissions'
  },
  getManagerList: {
    method: 'get',
    url: 'manager'
  },
  reviseManager: {
    method: 'put',
    url: 'manager'
  },
  deleteManager: {
    method: 'delete',
    url: 'manager'
  },
  addManager: {
    method: 'post',
    url: 'manager'
  },
  getPermissionList: {
    method: 'get',
    url: 'manager/permission'
  },
  revisePermission: {
    method: 'put',
    url: 'manager/permission'
  },
  deletePermission: {
    method: 'delete',
    url: 'manager/permission'
  },
  addPermission: {
    method: 'post',
    url: 'manager/permission'
  },
  getRoleList: {
    method: 'get',
    url: 'manager/role'
  },
  reviseRole: {
    method: 'put',
    url: 'manager/role'
  },
  deleteRole: {
    method: 'delete',
    url: 'manager/role'
  },
  addRole: {
    method: 'post',
    url: 'manager/role'
  },
  getRolePermission: {
    method: 'get',
    url: 'manager/role/permissions'
  },
}
